import {
  CHROMA_COLLECTION_FAILED,
  CHROMA_COLLECTION_REQUEST,
  CHROMA_COLLECTION_SUCCESS,
} from "app/redux/actions/SeriesProduct/ChromaCollection/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const chromaCollectionReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case CHROMA_COLLECTION_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case CHROMA_COLLECTION_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case CHROMA_COLLECTION_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
